import { StitchyPanelSettings } from '@modules/chat/services/stitchy-panel-settings.service';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ChatPanelComponent } from '@modules/chat/components/chat-panel/chat-panel.component';
import { ChatPanelStore } from '@modules/chat/services/chat-panel.service';
import { TopProgressTaskComponent } from '@modules/top-progress/top-progress-task.component';

/** Keep the assistant's draft alive after its first opening, without downloading its UI at startup. */
@Component({
  selector: 'app-lazy-stitchy-panel',
  host: { class: 'contents' },
  imports: [ChatPanelComponent, TopProgressTaskComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@defer (when store.isOpen()) {
      <app-chat-panel [style.display]="hidden() ? 'none' : null" [hostHidden]="hidden()" />
    } @loading {
      <stch-top-progress-task />
    }`,
})
export class LazyStitchyPanelComponent {
  private readonly settings = inject(StitchyPanelSettings);
  /** The side panel hides a docked assistant: the panel is told, so a reloaded screen waits until it can be seen. */
  public readonly hidden = input(false);
  protected readonly store = inject(ChatPanelStore);
}
